import { Grid, TextField, Typography } from "@material-ui/core"
import { yupResolver } from "@hookform/resolvers"
import * as yup from "yup"
import * as t from "prop-types"
import { Autocomplete } from "@material-ui/lab"
import React, {
  forwardRef,
  useContext,
  useImperativeHandle,
  useState,
} from "react"
import CustomerDisplay from "components/delivery-note/CustomerDisplays"
import { useForm } from "react-hook-form"
import { purgeInitialFormData } from "utils/form-data"
import { transformProperty } from "utils/objects"

import ReceiptOfInvoiceContext from "./ReceiptOfInvoiceContext"
import { CUSTOMER_BLANK_FORMS } from "./const"

const schema = yup.object().shape({
  customerId: yup.number().required(),
})

const ReceiptOfInvoiceCustomerForm = forwardRef(
  // eslint-disable-next-line react/prop-types
  ({ fetchCustomerData, initialValue }, ref) => {
    const [initialFormData] = useState(() =>
      purgeInitialFormData(initialValue, CUSTOMER_BLANK_FORMS)
    )

    const { selectedCustomer, setSelectedCustomer } = useContext(
      // ReceiptOfInvoiceContext
      ReceiptOfInvoiceContext
    )

    const {
      register,
      errors,
      // setValue,
      getValues,
      // control,
      handleSubmit,
    } = useForm({
      defaultValues: initialFormData,
      resolver: yupResolver(schema),
      // context: { invoiceType },
    })

    const [customers, setCustomers] = React.useState([])

    useImperativeHandle(ref, () => ({
      getFormData: () => {
        const data = getValues()
        transformProperty(data, ["customerId"], parseInt)
        return data
      },
      submitForm: async () => {
        return new Promise((res, rej) => handleSubmit(res, rej)())
      },
    }))

    React.useEffect(() => {
      let active = true

      const fetchData = async () => {
        const response = await fetchCustomerData()

        if (!active) return

        setCustomers(response)
      }

      fetchData()

      return () => {
        active = false
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
      <Grid item md={6}>
        <Typography variant="h6" style={{ marginBottom: "10px" }}>
          Customer Data
        </Typography>

        <Autocomplete
          options={customers}
          getOptionLabel={(opt) => (opt ? `${opt.custCode} (${opt.name})` : "")}
          renderOption={(opt) => <CustomerDisplay customerData={opt} />}
          value={selectedCustomer}
          getOptionSelected={(opt, val) => {
            return opt.idCust === val?.idCust
          }}
          onChange={(e, val) => {
            setSelectedCustomer(val)
          }}
          renderInput={(params) => (
            <TextField
              label="Customer Name"
              {...params}
              fullWidth
              margin="dense"
              error={!!errors?.customerId}
              helperText={errors?.customerId?.message}
            />
          )}
        />

        <input
          type="hidden"
          name="customerId"
          ref={register}
          value={selectedCustomer?.idCust ?? ""}
        />
      </Grid>
    )
  }
)

ReceiptOfInvoiceCustomerForm.propTypes = {
  fetchCustomerData: t.func.isRequired,
}

export default ReceiptOfInvoiceCustomerForm
